export default __webpack_public_path__ + "media/images/icons/diagonal-arrow-194c2b9303b4d1973c22e0d11377ab74.svg";